import RequestService from 'services/request.service'

import { DeckUserEditorLinkResponseType } from 'services/apiTypes/collaborators.types'

export function list(deckId: string | number): Promise<DeckUserEditorLinkResponseType> {
  return RequestService.get(`/api/decks/${deckId}/editors/`)
}

export function _delete(collaborationId: string | number): Promise<any> {
  return RequestService.delete(`/api/decks/editors/${collaborationId}/`)
}

export function post(deckId: string | number, userId: string | number): Promise<any> {
  return RequestService.post(`/api/decks/${deckId}/editors/`, { user: userId })
}

export default {
  list,
  post,
  delete: _delete,
}
